import roboImage from '@/assets/images/robo-triste.png'
import { Box, Container, Typography } from '@mui/material'

export function MaintenancePage() {
  return (
    <Container>
      <Box
        height="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
        textAlign="center"
      >
        <Box
          component="img"
          src={roboImage}
          alt="Imagem do Alume robo triste"
          sx={{ width: 200 }}
        />

        <Typography variant="h2">Desculpe! Estamos em manutenção</Typography>
        <Typography fontSize={18}>
          Nosso app está em manutenção e iremos retornar em breve.
        </Typography>
      </Box>
    </Container>
  )
}
